import React, { useEffect, useMemo } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { useAIEventsInstrumentation } from '@atlassian/ai-analytics';
import { useSAINUsageCriteriaMet } from '../../common/controller/analytics';
import { CardTemplate } from '../../constants';
import { useAIAnswerContext } from '../ai-answer-context';
import { NLPSearchResultFormat } from '../types';
import { AIAnswerError, JsonResultComponent, PlaintextResultComponent, RenderedResultComponent } from './ai-answer-result';
import { AIAnswerBodyWrapper, AIAnswerErrorWrapper } from './styled';
var AIAnswerResult = function AIAnswerResult() {
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var _useAIEventsInstrumen = useAIEventsInstrumentation(),
    trackAIResultView = _useAIEventsInstrumen.trackAIResultView;
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var answerFormat = commonAttributes.answerFormat;
  useEffect(function () {
    fg('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
      commonAttributes: commonAttributes
    }) : trackAIResultView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var AIAnswerResultComponent = useMemo(function () {
    switch (answerFormat) {
      case NLPSearchResultFormat.ADF:
      case NLPSearchResultFormat.MARKDOWN:
        return RenderedResultComponent;
      case NLPSearchResultFormat.JSON:
        return JsonResultComponent;
      case NLPSearchResultFormat.PLAINTEXT:
      default:
        return PlaintextResultComponent;
    }
  }, [answerFormat]);
  return /*#__PURE__*/React.createElement(AIAnswerResultComponent, null);
};
export var AIAnswerBody = function AIAnswerBody() {
  var _useAIAnswerContext2 = useAIAnswerContext(),
    isAnswered = _useAIAnswerContext2.isAnswered,
    hasError = _useAIAnswerContext2.hasError,
    isReadingAids = _useAIAnswerContext2.isReadingAids,
    cardTemplate = _useAIAnswerContext2.cardTemplate;
  return /*#__PURE__*/React.createElement(AIAnswerBodyWrapper, {
    isReadingAids: isReadingAids && cardTemplate === CardTemplate.DEFAULT
  }, isAnswered && !hasError ? /*#__PURE__*/React.createElement(AIAnswerResult, null) : hasError ? /*#__PURE__*/React.createElement(AIAnswerErrorWrapper, null, /*#__PURE__*/React.createElement(AIAnswerError, null)) : null);
};